export default "__VITE_ASSET__WpXZWgsK__"